import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';
import { DataPoint } from '../utils/mockData';
interface WoundInfectionRiskChartProps {
  data: DataPoint[];
  currentIndex: number;
}
export const WoundInfectionRiskChart: React.FC<WoundInfectionRiskChartProps> = ({
  data,
  currentIndex
}) => {
  const [showComparison, setShowComparison] = useState(true);
  const isMobile = window.innerWidth < 640;
  // Prepare chart data
  const currentData = data[currentIndex];
  const chartData = currentData.days.map((day, idx) => {
    // Get the current risk value
    const riskValue = currentData.woundInfectionRiskValues[idx] || 0;
    // Determine the color based on the risk value, not the overall status
    let color = '#10B981'; // green
    if (riskValue >= 60) {
      color = '#EF4444'; // red
    } else if (riskValue >= 30) {
      color = '#F59E0B'; // yellow
    }
    return {
      day,
      current: riskValue,
      baseline: 15,
      threshold: 60,
      color
    };
  });
  return <div className="h-full" data-id="element-254">
      <div className="flex justify-end mb-2" data-id="element-255">
        <label className="inline-flex items-center" data-id="element-256">
          <input type="checkbox" className="form-checkbox h-3 w-3 sm:h-4 sm:w-4 text-blue-600" checked={showComparison} onChange={() => setShowComparison(!showComparison)} data-id="element-257" />
          <span className="ml-1 sm:ml-2 text-xs sm:text-sm text-gray-700" data-id="element-258">
            Show threshold
          </span>
        </label>
      </div>
      <ResponsiveContainer width="100%" height="90%" data-id="element-259">
        <LineChart data={chartData} margin={{
        top: 5,
        right: isMobile ? 10 : 30,
        left: isMobile ? 40 : 60,
        bottom: 5
      }} data-id="element-260">
          <CartesianGrid strokeDasharray="3 3" data-id="element-261" />
          <XAxis dataKey="day" tick={{
          fontSize: isMobile ? 10 : 12
        }} label={{
          value: 'Time (Days)',
          position: 'insideBottomRight',
          offset: -10,
          fontSize: isMobile ? 10 : 12
        }} data-id="element-262" />
          <YAxis domain={[0, 100]} tick={{
          fontSize: isMobile ? 10 : 12
        }} label={{
          value: 'Wound Infection Risk (%)',
          angle: -90,
          position: 'outside',
          dx: isMobile ? -20 : -35,
          dy: isMobile ? 0 : 0,
          fontSize: isMobile ? 10 : 12
        }} data-id="element-263" />
          <Tooltip formatter={(value: number) => `${value.toFixed(1)}%`} contentStyle={{
          fontSize: isMobile ? 10 : 12
        }} data-id="element-264" />
          <Legend wrapperStyle={{
          fontSize: isMobile ? 10 : 12
        }} data-id="element-265" />
          <Line type="monotone" dataKey="current" name="Wound Infection Risk" stroke={currentData.healthStatus === 'green' ? '#10B981' : currentData.healthStatus === 'yellow' ? '#F59E0B' : '#EF4444'} strokeWidth={isMobile ? 2 : 3} dot={{
          r: isMobile ? 0 : 1,
          fill: entry => entry.color,
          stroke: entry => entry.color
        }} activeDot={{
          r: isMobile ? 3 : 5
        }} data-id="element-266" />
          {showComparison && <ReferenceLine y={60} stroke="red" strokeDasharray="3 3" label={{
          value: '',
          position: 'right',
          fill: 'red',
          fontSize: isMobile ? 10 : 12
        }} data-id="element-267" />}
        </LineChart>
      </ResponsiveContainer>
    </div>;
};